import {Component, EventEmitter, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-page-not-found-no-access',
  templateUrl: './page-not-found-no-access.component.html',
  styleUrls: ['./page-not-found-no-access.component.scss']
})
export class PageNotFoundNoAccessComponent implements OnInit {
  @Output() backToPrevPage = new EventEmitter();

  constructor() {
  }

  ngOnInit() {
  }

  goBack() {
    this.backToPrevPage.emit();
  }
}
